import { render, staticRenderFns } from "./slide-to-unlock.vue?vue&type=template&id=6fab7b01&scoped=true&"
import script from "./slide-to-unlock.vue?vue&type=script&lang=ts&"
export * from "./slide-to-unlock.vue?vue&type=script&lang=ts&"
import style0 from "./slide-to-unlock.vue?vue&type=style&index=0&id=6fab7b01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab7b01",
  null
  
)

export default component.exports